import RaceCalendar from "./raceCalendar";

export default function Spectators() {
    return (
        <RaceCalendar target='/spectator/%SOURCE%/%RxCx%'/>
    )
}